import { StatusBadge } from "../../../components/ui/statusBadge/StatusBadge";
import { TRIP_STATUS } from "../../../constants/tripStatus";
import { buildTripPortalUrl } from "../../../utils/portalLinks";

export function TripViewHeader({ circuit, dateId, onBack }) {
  const isPublished = circuit.statut === TRIP_STATUS.PUBLISHED;

  return (
    <div className="page-header">
      <div>
        <div className="breadcrumb">
          <a onClick={onBack}>Circuits</a>
          <i className="fa-solid fa-chevron-right"></i>{circuit.nom}
        </div>
        <h1 className="page-title">{circuit.nom}</h1>
        <div className="page-sub" style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span className="mono">{circuit.id}</span>
          <StatusBadge statut={circuit.statut} domain="trip" />
        </div>
      </div>
      <div className="page-actions">
        {isPublished ? (
          <a
            className="btn"
            data-testid="btn-view-on-portal"
            href={buildTripPortalUrl(circuit.id, dateId)}
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-solid fa-arrow-up-right-from-square"></i> Voir sur le portail
          </a>
        ) : null}
      </div>
    </div>
  );
}

export default TripViewHeader;
